import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

const links = [
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  { href: "#results", label: "Track Record" },
  { href: "#insights", label: "Insights" },
  { href: "#testimonials", label: "Testimonials" },
  { href: "#faq", label: "FAQ" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-2xl bg-black/60 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between py-4">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2 group">
          <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" />
          <span className="font-serif-display text-xl tracking-wider text-white">
            LEO <span className="text-amber-500">BIANCHI</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-zinc-400 hover:text-white transition-colors duration-300 tracking-wide"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Button
            asChild
            data-testid="nav-book-call-btn"
            className="bg-amber-600 hover:bg-amber-500 text-black font-medium rounded-full px-6 hidden sm:inline-flex"
          >
            <a href="#book">Book a Call</a>
          </Button>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden text-white p-2"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
          >
            <span className="block w-6 h-px bg-white mb-1.5" />
            <span className="block w-6 h-px bg-white mb-1.5" />
            <span className="block w-4 h-px bg-white ml-auto" />
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-zinc-300 hover:text-white"
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href="#book"
              onClick={() => setOpen(false)}
              data-testid="mobile-book-call"
              className="bg-amber-600 text-black px-5 py-2 rounded-full text-center mt-2"
            >
              Book a Call
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
